//Obtiene el nombre de la imagen con el código desde el localstorage
// export const getImage = (cod) => {
//   const storedImages = localStorage.getItem("Images");
//   if (storedImages !== null && storedImages !== undefined) {
//     const images = JSON.parse(storedImages);
//     if (images) {
//       //console.log("IMAGEN", images)
//       if (images[0]?.ImagenesRuta) return images[0].ImagenesRuta;
//       const survey = process.env.REACT_APP_NAME_FORM;
//       const image = images.find(
//         (img) => img.TiposImagenesCodigoInternoId == cod
//       );
//       //console.log(images, cod)
//       if (image) {
//         return `assets/${survey}/${image.ImagenesNombreArchivo}`;
//       } else {
//         return "";
//       }
//     } else return "";
//   } else return "";
// };

export const getImage = (cod, encuestaNueva) => {
    const storedImages = localStorage.getItem("Images");
  
    if (storedImages !== null && storedImages !== undefined) {
      const images = JSON.parse(storedImages);
  
      if (images) {
        if (images[0]?.ImagenesRuta) return images[0].ImagenesRuta;
        const image = images.find(
          (img) => img.TiposImagenesCodigoInternoId == cod
        );
  
        if (image && encuestaNueva) {
          return `/assets/${encuestaNueva}/${image.ImagenesNombreArchivo}`;
        } else {
          return "";
        }
      } else return "";
    } else return "";
  };